import styled from "styled-components";

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const LoaderTextWrapper = styled.div`
    max-width: 40rem;
    display: flex;
    flex-direction: column;
    margin: auto;
    gap: 1rem;
    margin-bottom: 1rem;
`;
